import Vue from 'vue'
import Router from 'vue-router'
import upmsRouter from './upms'
import businessRouter from './business'
// import app from '@/main.js'
// import { mapMutations } from 'vuex'
import store from '@/store'

Vue.use(Router)
export const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login')
  },
  {
    path: '/Guide',
    name: 'Guide',
    component: () => import('@/views/Guide')
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('@/views/business/video/videoTest')
  },
  {
    path: '/tableData/:id/:queryDate/:type',
    name: 'tableData',
    component: () => import('@/views/business/report/TableData'),
    props: true
  },
  businessRouter,
  upmsRouter
]
const createRouter = () => new Router({
  routes,
  duplicateNavigationPolicy: 'ignore'
})
const router = createRouter()
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

router.beforeEach((to, from, next) => {
  store.commit('SHOW_TREE', false)
  const showTree = treeDomWhiteList.some(t => {
    return t === to.name
  })
  if (to.meta.title) { // 判断是否有标题
    document.title = `能源管理系统-${to.meta.title}`
  }
  store.commit('SHOW_TREE', showTree)

  next()
})
// / 树形DOM展示与否的白名单;有就展示 === KEY for name
const treeDomWhiteList = [
  'zhcx',
  'yncx',
  'compare',
  'peakValley',
  'historical',
  'loadAnalysis',
  'realStatus', // 实时状态
  'dataStatistics', // 数据统计
  'operationAndMaintenanceInformation' // 运维信息
]

export default router
